function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.757812,
    width: 70.7174,
    height: 70.7174,
    rx: 12.1927,
    fill: "#E69DE5",
    style: {
      fill: "#E69DE5",
      fill: "color(display-p3 0.9010 0.6151 0.8968)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8141 40.0624C52.0761 42.8179 50.6259 45.3306 48.609 47.3479C46.5922 49.3652 44.0799 50.8161 41.3246 51.5546C38.5693 52.2932 35.6681 52.2935 32.9127 51.5554C30.1572 50.8173 27.6446 49.3669 25.6274 47.35C23.6102 45.333 22.1595 42.8206 21.4211 40.0653C20.6827 37.3099 20.6826 34.4088 21.4208 31.6534C22.159 28.898 23.6096 26.3854 25.6266 24.3684C27.6437 22.3513 30.1562 20.9007 32.9116 20.1624M53.3666 35.8574C53.3666 31.5477 51.6545 27.4144 48.607 24.3669C45.5596 21.3195 41.4263 19.6074 37.1166 19.6074V34.6074C37.1166 34.9389 37.2483 35.2569 37.4827 35.4913C37.7171 35.7257 38.035 35.8574 38.3666 35.8574H53.3666Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.bc2397195ec3fdb17e11ea8faee2a92e.svg";
export { ForwardRef as ReactComponent };